import { FCX, ID } from "@datassential/platform-ui-lib";
import { useHomeCategoryLensAllLtos } from "@apiHooks/useHomeCategoryLensAllLtos";
import HomeSectionSubTitle from "@pages/Home/components/HomeSectionSubTitle";
import HomeLtosSection from "@pages/Home/components/HomeLtosSection";
import HomeSectionLoader from "@pages/Home/components/HomeSectionLoader";
import { LR_APPLY_FILTERS_PATH, LR_CATEGORIES_IDS_PARAM } from "@pages/Home/constants";

interface CategoryLensLtosProps {
    categoryName: string;
    categoryId: ID;
}

const CategoryLensLtos: FCX<CategoryLensLtosProps> = ({ categoryName, categoryId }) => {
    const { isLoading, data } = useHomeCategoryLensAllLtos();

    const footerLinkLabel = categoryId !== 0 ? `More ${categoryName} Launches` : '';
    const footerLinkPath = categoryId !== 0 ? `${LR_APPLY_FILTERS_PATH}?${LR_CATEGORIES_IDS_PARAM}=${categoryId}` : '';

    if (isLoading) return <HomeSectionLoader />;

    return (
        <HomeLtosSection
            data={data}
            maxRowsCount={1}
            categoryId={categoryId}
            footerLinkLabel={footerLinkLabel}
            footerLinkPath={footerLinkPath}
            topPerformingMonths={12}
            headerContent={<HomeSectionSubTitle>Top performing Launches: {categoryName}</HomeSectionSubTitle>}
        />
    );
};

export default CategoryLensLtos;